import React, { Component } from 'react'
import PrivateRoute from '../../PrivateRoute'
import { Switch } from 'react-router-dom'
import Grid from './grid'
import Form from './form'
import FormDevice from './dispositivos/form'
import FormGroupMulticast from './gruposMulticast/form'

export default class Aplicacao extends Component {
    render() {
        return (
            <div className="hdv-render-div">
                <div className="col-md-12 hdv-bloco-top-space hdv-zera-padding-left-right-boostrap">
                    <Switch>
                        <PrivateRoute exact path='/lns/application' component={Grid} />
                        <PrivateRoute path='/lns/application/novo' component={Form} />
                        <PrivateRoute path='/lns/application/:id/editar/:idTab?' component={Form} />
                        <PrivateRoute path='/lns/application/:id/device/novo/:idCliente?' component={FormDevice} />  
                        <PrivateRoute path='/lns/application/:id/device/:idDevice/editar/:idCliente?' component={FormDevice} />   
                        <PrivateRoute path='/lns/application/:id/multicast-group/novo' component={FormGroupMulticast} />  
                        <PrivateRoute path='/lns/application/:id/multicast-group/:idGroup/editar' component={FormGroupMulticast} />
                    </Switch>
                </div>
            </div>
        )
    }
}